import config from "../boot/config";
import http from "../boot/http.js";

const route = "Site/";

export default class {
   static FailedRulesForSites(siteNamesList) {
      let url = `${config.baseUrl + route}FailedRulesForSites`;

      return http({ url, method: "POST", data: siteNamesList })
         .then(data => data)
         .catch(error => error);
   }

   static FailedRulesForSitesHistorical(siteNamesList, from, to) {
      let url = `${config.baseUrl + route}FailedRulesForSitesHistorical`;

      return http({ url, method: "POST", data: siteNamesList, from, to})
            .then(data => data)
            .catch(error => error);
   }

   static GetDataForSites(siteNamesList, from, to) {
      let url = `${config.baseUrl + route}GetDataForSites`;

      return http({ url, method: "POST", data: siteNamesList, from, to })
         .then(data => data)
         .catch(error => error);
   }
}



// WEBPACK FOOTER //
// ./src/services/sites.js